import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ClosingReasonsAPI from '../../api/closingReasons';

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getClosingReasons(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  }
};

export const actions = {
  get: async ({ commit }, params) => {
    commit(types.SET_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isFetching: true });
    commit(types.SET_META, {});

    try {
      const { page, sortAttr, limit } = params;
      const response = await ClosingReasonsAPI.get(page, sortAttr, limit);

      commit(types.SET_CLOSING_REASONS, response.data.payload);
      commit(types.SET_META, response.data.meta);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isCreating: true });

    try {
      const response = await ClosingReasonsAPI.create(data);

      commit(types.ADD_CLOSING_REASONS, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isDeleting: true });

    try {
      await ClosingReasonsAPI.delete(id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isDeleting: false });
    }
  },
  search: async ({ commit }, params) => {
    commit(types.SET_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isFetching: true });
    commit(types.SET_META, {});

    try {
      const { page, sortAttr, search } = params;
      const response = await ClosingReasonsAPI.search(page, sortAttr, search);

      commit(types.SET_CLOSING_REASONS, response.data.payload);
      commit(types.SET_META, response.data.meta);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_CLOSING_REASONS_TEMPLATE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_META](_state, data) {
    _state.meta = data;
  },

  [types.ADD_CLOSING_REASONS]: MutationHelpers.create,
  [types.SET_CLOSING_REASONS]: MutationHelpers.set,
  [types.DELETE_CLOSING_REASONS]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
